export enum actions {
    LOADING,
    SUCCESS,
    FAIL,
}

export const APPLICATION_LANGUAGE = 'ar';
